'use client';
import React from "react";
import styles from "./SuccessStories.module.scss";

const stories = [
  {
    category: "Fashion Retail",
    className: "fashion",
    title:
      "AI styling help customers find perfect outfits based on preferences, body type, and occasion.",
    description:
      "Implementation of AI shopping assistants led to personalized styling recommendations.",
    results: [
      "45% increase in average order value",
      "60% reduction in returns",
      "3x higher engagement",
    ],
  },
  {
    category: "Electronics",
    className: "electronics",
    title:
      "Intelligent product assistance and compatibility checking for complex electronics purchases.",
    description:
      "AI-powered assistance reduced support tickets while improving customer satisfaction.",
    results: [
      "70% reduction in support tickets",
      "85% accuracy in recommendations",
      "90% customer satisfaction",
    ],
  },
  {
    category: "Home & Garden",
    className: "home",
    title:
      "Smart planning and product recommendations for home improvement projects.",
    description:
      "Intelligent product recommendations helped customers find exactly what they needed.",
    results: [
      "55% increase in project completion",
      "40% higher customer satisfaction",
      "25% boost in repeat purchases",
    ],
  },
];
function SuccessStories() {
  return (
    <section className={styles.successStories} id="use-cases">
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2>Success Stories Across Industries</h2>
          <p>
            See how different industries are leveraging agentic commerce to
            transform their customer experiences.
          </p>
        </div>
        <div className={styles.storiesGrid}>
          {stories?.map((story, index) => (
            <div key={index} className={styles.storyCard}>
              <div
                className={`${styles.storyImage} ${styles[story.className]}`}
              >
                <div className={styles.storyCategory}>{story.category}</div>
              </div>
              <div className={styles.storyContent}>
                <h3>{story.title}</h3>
                <p>{story.description}</p>
                <div className={styles.storyResults}>
                  <h4>Key Results:</h4>
                  <ul>
                    {story.results.map((result, i) => (
                      <li key={i}>{result}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SuccessStories;
